






























































import { Component, Vue } from 'vue-property-decorator';
import { IServiceBanPolicy } from '@/interfaces';
import {
  readServiceBanPolicies,
  dispatchGetServiceBanPolicies,
  dispatchDeleteServiceBanPolicies,
  dispatchDeleteServiceBanPolicy,
} from '@/store/admin/accessors';

@Component
export default class ServiceBanPolicies extends Vue {
  public search: string = '';

  public selected: IServiceBanPolicy[] = [];
  public pagination: { rowsPerPage; footerProps } = {
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public headers = [
    {
      text: 'Service',
      sortable: true,
      value: 'service_name',
      align: 'left',
    },
    {
      text: 'Ban Multiplier',
      sortable: true,
      value: 'ban_multiplier',
      align: 'left',
    },
    {
      text: 'Max Bans',
      sortable: true,
      value: 'max_bans',
      align: 'left',
    },
    {
      text: 'Permanent Duration',
      sortable: true,
      value: 'permanent_ban_duration',
      align: 'left',
    },
    {
      text: 'Repeated Ban',
      sortable: true,
      value: 'repeated_ban',
      align: 'left',
    },
    {
      text: 'MO Unban',
      value: 'mo_unban',
      align: 'left',
    },
    {
      text: 'MT Unban',
      value: 'mt_unban',
      align: 'left',
    },
    {
      text: 'Actions',
      value: 'id',
    },
  ];

  get banPolicies() {
    return readServiceBanPolicies(this.$store);
  }

  public async mounted() {
    await dispatchGetServiceBanPolicies(this.$store);
  }

  public async deleteServiceBanPolicy(id: number) {
    if (confirm('Are you sure you want to delete this ban policy?')) {
      await dispatchDeleteServiceBanPolicy(this.$store, id);
      await dispatchGetServiceBanPolicies(this.$store);
    }
  }

  public async deleteServiceBanPolicies() {
    if (confirm('Are you sure you want to delete selected ban policies?')) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteServiceBanPolicies(this.$store, selected);
      await dispatchGetServiceBanPolicies(this.$store);
    }
  }
}
